import {gsap} from "gsap";

const Articles = {

    init() {
        this.el = $('[module="articles"]');
        if (!this.el.length) return;

        this.images = this.el.find('[block="images"]');
        if (!this.images.length) return;

        this.gallery = this.el.find(".gallery");
        this.galleryButtonClose = this.gallery.find(".hide");

        this.bind();
    },

    bind() {
        this.images.children().click((evt) => {
            this.createGallery($(evt.currentTarget).index());
            return false;
        });

        this.galleryButtonClose.click((evt) => {
            this.removeGallery();
            return false;
        });
    },

    createGallery(image) {
        const html = this.images.clone();
        const slider = this.gallery.find(".slider");

        html.find('.image').each((i, el)=>{
            let url = $(el).find('img').attr('src').split('?')[0];
            $(el).find('img').attr('src', url).appendTo(slider);
        })

        this.initSlider(slider, image);
    },

    initSlider(slider, image){
        slider.addClass('owl-carousel')
            .owlCarousel({
                // "loop": true,
                "autoWidth": false,
                "nav": true,
                "dots": true,
                "progress": false,
                "counter": false,
                "margin": 0,
                "stagePadding": 0,
                "items": 1,
                "navText": ["", ""],
                "current": image,
            })
        .trigger('to.owl.carousel', image);
        this.showGallery();
    },

    showGallery() {
        this.gallery.removeClass("hidden");
        this.gallery.addClass("visible");
        this.galleryButtonClose.focus();

        setTimeout(() => {
            this.gallery.addClass("animation");
        }, 1000);
    },

    removeGallery() {
        this.gallery.removeClass("visible");
        setTimeout(() => {
        this.gallery.addClass("hidden animation");
        }, 500);

        setTimeout(() => {
            this.gallery.find(".slider").trigger('destroy.owl.carousel').empty().removeClass('owl-carousel');
        }, 1000);
    }
};

export default Articles;